import React from 'react'
import '../styles/comps.css'
import UserAvatar from './userAvatar'
import loadingRing from '../img/EBD428F1-DF85-4FFB-80F5-1E799D849F44.GIF'
import loadingHead from '../img/DE3B321F-17B8-4D1C-B2C5-F53F205D27E2.GIF'
import loadingPortrait from '../img/4DCCC114-CD4B-4844-8585-12D71C1BDF2B.GIF'

export const Input = props =>{
  return(
  <div>  <input placeholder={props.placeholder} value={props.value} onChange={props.onChange} onFocus={props.onFocus} onBlur={props.onBlur} className="Input"/></div>
  )
}

export const PasswordInput = props =>{
  return(
  <div className="Input passwordInput">
    <input type={props.eye ? 'password' : 'text'} placeholder={props.placeholder} value={props.value} onChange={props.onChange} />
    <span className="passwordEye" onClick={props.passwordEyeAction}>{!props.eye?props.show:props.showed}</span>
  </div>
  )
}

export const InputErrorMassage = props =>{

  if(props.val.length < props.num[0] || props.val.length > props.num[1]){
    return(<p className='InputErrorMassage'>{props.text}</p>);
  }else{
  return(<></>

  )}
}

export const BigInput = props =>{
  return(
  <div>  <textarea type='textinput' style={{height: props.height}} placeholder={props.placeholder} value={props.value} onChange={props.onChange} className="Input" ></textarea></div>
  )
}

export const Button = props =>{
      const playSound = () => {new Audio('./click.mp3').play()}
  return(
  <div onClick={playSound}>  <button className='Button' onClick={props.click}>{props.title}</button></div>
  )
}
export const MaltyButton = props =>{
  return(
  <div className="MaltyButton"> <button style={{backgroundColor: props.color1}} onClick={props.click1}>{props.title1}</button><button style={{backgroundColor: props.color2}} onClick={props.click2}>{props.title2}</button></div>
  )
}

export const Select = props =>{
  var list = props.list;
  return(
  <div>  <select autoComplete={props.autoComplete || 'off'} value={props.value} onChange={props.onChange} className="Select">
{list.map((item,index)=>{return(
<option key={item} value={item}>{item}</option>
    )})}</select></div>
)
}

export const MiddleImage = props => {
return(
<div className="Image"><img alt={`iciskare`} src={props.Photo} /></div>
)
}

export const Lines = props => {
return(
  <div>
  <div className="line1" ><div></div><div></div></div>
  <div className='line2'><div></div><div></div></div>
</div>
)
}

export const ShowDiv = props => {
      const playSound = () => {new Audio('./click.mp3').play()}
return(
  <div onClick={props.click} className={props.is?'ShowDiv color':'ShowDiv'}>
   <div onClick={playSound}>{props.icon}</div>
  <p>{props.title}</p>
</div>
)
}
export const ShowDivshort = props => {
      const playSound = () => {new Audio('./click.mp3').play()}
return(
  <div onClick={props.click} className={props.is?'ShowDivshort color':'ShowDivshort'}>
   <div onClick={playSound}>{props.icon}</div>
  <p>{props.title}</p>
</div>
)
}
export const Flex = props => {
return(
  <div className="Flex">
{props.children}
</div>
)
}

export const ButtonInput = props => {

return(
  <div className={props.bigType?"ButtonInputBig":"ButtonInput"}>
     {/* style={{width: props.width,height: props.height}} */}
<input placeholder={props.placeholder} value={props.value} onChange={props.onChange} />
<button onClick={props.click}>{props.title}</button>
</div>
)
}

export const PeopleList = props => {
return(
  <div className="PeopleList" style={{height: props.height,width: props.width}}>
    {props.list.map((item,index)=>{return(
    <div key={item.id}><UserAvatar alt={`iciskare ${item.email}`} name={item.email} src={item.userImg} /><div><p className="emailComments">{item.email}</p><p>{item.content}</p><p className="dateComments">{item.date}</p><p><span onClick={()=>props.onlike(item.id)}><i className="far fa-thumbs-up"></i>{item.pCount}</span>  <span  onClick={()=>props.ondlike(item.id)}><i className="far fa-thumbs-down"></i>{item.dCount}</span></p></div></div>
        )})}
</div>
)
}

export const EmptyMassage = props => {
  if (props.loading) {
    return (
      <div className={props.video ? 'EmptyMassagevideos' : 'EmptyMassage'}>
        <SpinerLoad compact />
      </div>
    )
  }
  if(!props.list || props.list.length === 0){
return(
  <div className={props.video?'EmptyMassagevideos':"EmptyMassage"}>
<p style={{color:props.color}}>{props.title}</p>
</div>
)}else{
  return null
}
}

export const FeedLoadBar = () => (
  <div className="feedLoadBar" role="status" aria-label="Loading more">
    <span />
  </div>
)

export const SpinerLoad = props => {

return(
  <div className={`spinerLoadMain${props.compact ? ' spinerLoadMainCompact' : ''}`} role="status" aria-live="polite">
    <div className="spinerLoad">
      <div className="spinerLoadWindow">
        <img className="spinerLoadImage spinerLoadImageRing" src={loadingRing} alt="" />
        <img className="spinerLoadImage spinerLoadImageHead" src={loadingHead} alt="" />
        <img className="spinerLoadImage spinerLoadImagePortrait" src={loadingPortrait} alt="" />
      </div>
    </div>
    <span className="spinerLoadText">Loading</span>
  </div>
)
}

export const DoubleLinks = props =>{
  return(
    <div className='DoubleLinks'>
    <span onClick={props.clickP}>See Website Policy ?</span><span onClick={props.clickA}>Some Info About Us ?</span>
    </div>
  )
}
